import { useState } from 'react';
import Dropzone from 'react-dropzone';

import { Trash } from "lucide-react";
import { LoadingSpinner, Thumbnail, cn } from "twyne-new.ui";

import { useImages } from '@/components/builder/utils/tailwindConfig/hooks';
import httpClient from 'utils/httpclient';

export async function uploadImage(file, onProgress) {
  const payload = new FormData()
  payload.append('image', file)
  const { data } = await httpClient.post(`/api/cms/image`, payload, {
    onUploadProgress: e => e.total && onProgress?.(Math.round(e.loaded * 100 / e.total)),
  })
  return {
    src: data.location,
    name: data.originalname,
    contentType: data.contentType,
  }
}

export default function Images({ enableSelect, onSelect }) {
  const { value: images, setValue: setImages } = useImages()
  const [isUploading, setIsUploading] = useState(false)

  const handleImageUpload = async files => {
    const uploadedImages = []
    setIsUploading(true)

    for (const file of files) {
      const image = await uploadImage(file)
      uploadedImages.push(image)
    }

    setImages([...Array.isArray(images) ? images : [], ...uploadedImages])
    setIsUploading(false)
  }

  const handleImageRemove = (e, index) => {
    e.stopPropagation()
    setImages(images.filter((_, i) => i !== index))
  }

  return <div className="columns-5">
    <Dropzone
      multiple
      accept="image/*"
      className="m-1 flex flex-col items-center justify-center border gap-2 twy-border-base rounded-md p-10 cursor-pointer"
      onDrop={files => handleImageUpload(files)}
      disabled={isUploading}
    >
      <div>
        {isUploading ? <LoadingSpinner /> : <Thumbnail size="lg" />}
      </div>
      <span>
        {isUploading ? 'Uploading...' : 'Select or drop images here'}
      </span>
    </Dropzone>
    {images?.map?.(({ src, name, contentType }, index) => <div key={index} className={cn("relative group min-h-15 p-1 my-2", enableSelect && 'cursor-pointer hover:ring-2 hover:twy-ring-accent transition-all duration-300 rounded-md', ['image/png', 'image/svg+xml'].includes(contentType) ? 'bg-white bg-[linear-gradient(45deg,#e5e7eb_25%,transparent_25%),_linear-gradient(-45deg,#e5e7eb_25%,transparent_25%),_linear-gradient(45deg,transparent_75%,#e5e7eb_75%),_linear-gradient(-45deg,transparent_75%,#e5e7eb_75%)] bg-[length:16px_16px] bg-[position:0_0,0_8px,8px_-8px,8px_0]' : '')} onClick={() => enableSelect && onSelect({ src, name })}>
      <img src={src} alt={name} className={cn('rounded-md')} />
      <Trash size={20} className="cursor-pointer absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300" color="red" onClick={e => handleImageRemove(e, index)} />
    </div>)}
  </div>
}
